import { ENTITY_IMAGES_PAGE_SIZE } from "../../../../../../src/shared/entityImages";
import { useEntityImages, type UseEntityImagesResult } from "../../../EntityImage/lib/useEntityImages";
import { worldbuildingImageApi } from "./api";

const fetchImagesPage = (entryId: string, cursor: string | undefined) => worldbuildingImageApi.list(entryId, { limit: ENTITY_IMAGES_PAGE_SIZE, cursor });

export function useWorldbuildingImages(entryId: string, { enabled }: { enabled: boolean }): UseEntityImagesResult {
  return useEntityImages({ queryKeyPrefix: "worldbuildingImages", entityId: entryId, fetchPage: fetchImagesPage, enabled, sentryFeature: "worldbuilding_image_list" });
}
